import React from 'react';
import { IMAGE_FALL_BACK_URL } from 'common/constants';
import { useTranslation } from 'react-i18next';
import { image } from './styles';

type Props = {
  width: number;
  height: number;
};

export const ImageFallback: React.FC<Props> = ({ width, height }) => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: width, maxHeight: height }}>
      <img
        className={image}
        data-qa="image-fallback"
        src={IMAGE_FALL_BACK_URL}
        alt={t('ui.image.alt')}
        loading="lazy"
        width={width}
        height={height}
      />
    </div>
  );
};
